export default "__VITE_ASSET__4687b971__"